import React, {useState} from "react";
import {Button, Grid} from "@mui/material";
import {useTranslation} from "react-i18next";
import SignatureCanvas from "react-signature-canvas";
import SignStep from "../../digital-sign/component/SignStep";
import {IDigitSignPair} from "./models";

export interface IAncillarySignatureBoxProps {
	/**
	 * Notifica al parent la firma corrente (base64 PNG) e se e' presente.
	 * La presenza della firma CLIENTE e' la condizione di conclusione dell'operazione (RF-03).
	 */
	onSignatureChange: (signatures: IDigitSignPair, customerPresent: boolean) => void;
}

/**
 * Box firma a mano (signature pad) per la conclusione delle operazioni ancillary post-firma
 * (LPP-22289 / SCFE-1, RDT §2.1(7)). Allineamento funzionale RF-03: e' richiesta la SOLA firma
 * del CLIENTE (immagine base64, non OTP/QR). NON la firma dell'operatore.
 */
const AncillarySignatureBox = ({onSignatureChange}: IAncillarySignatureBoxProps) => {
	const {t} = useTranslation(['network']);

	const [signRefCus, setSignRefCus] = useState<SignatureCanvas | null>(null);

	const toDataUrl = (ref: SignatureCanvas | null): string | null => {
		if (!ref || ref.isEmpty()) {
			return null;
		}
		return ref.getSignaturePad().toDataURL('image/png');
	};

	const handleCusPresence = (present: boolean) => {
		onSignatureChange(
			{customerDigitSign: present ? toDataUrl(signRefCus) : null},
			present
		);
	};

	const clearCus = () => {
		signRefCus?.clear();
		handleCusPresence(false);
	};

	return (
		<Grid container spacing={2} data-testid={'ancillary-signature-box'}>
			<Grid item xs={12}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<SignStep step={{"step-key": "customerSign", "step-url": "/signature"}}
								  signRef={signRefCus} setSignRef={setSignRefCus}
								  setSignIsPresent={handleCusPresence}/>
					</Grid>
					<Grid item>
						<Button variant="outlined" color="accent" size="small" onClick={clearCus}>
							{t('digitalSign.label.clear')}
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default AncillarySignatureBox;
